import React from 'react';
import { useIconThemed } from '../use-icon-themed';
export default function IconPanel() {
  var _useIconThemed = useIconThemed(),
    iconThemed = _useIconThemed.iconThemed;
  return /*#__PURE__*/React.createElement("svg", {
    focusable: "false",
    "aria-hidden": true,
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: iconThemed({
      light: '#FFF',
      dark: '#161A1D'
    }),
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: iconThemed({
      light: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
      dark: "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
    }),
    x: 8,
    y: 12,
    width: 32,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20a4 4 0 108 0 4 4 0 00-8 0z",
    fill: iconThemed({
      light: "var(--ds-icon-information, #1D7AFC)",
      dark: "var(--ds-icon-information, #1D7AFC)"
    }),
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: iconThemed({
      light: '#FFF',
      dark: '#09326C'
    }),
    fillRule: "nonzero",
    x: 15.556,
    y: 19.722,
    width: 1,
    height: 2.2,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: iconThemed({
      light: '#FFF',
      dark: '#09326C'
    }),
    fillRule: "nonzero",
    cx: 16,
    cy: 18.444,
    r: 1
  })));
}